/**
 * Messages module translations - Labels section
 */

const labels = {
  search: "Search",
  all: "All",
  new: "New",
  marked: "Marked",
  sender: "Sender",
  subject: "Subject",
  text: "Text",
  applications: "Applications",
  fileTypesHint: "Choose *jpg, *jpeg, *png files to upload",
  viewDetails: "View details for",
  deleteMessage: "Delete message",
  doYouWantToDel: "Do you want to delete message",
  nothingFound: "Nothing found",
  tryToChange: "Try to change your filters",
  youWillBeInformed: "You will be informed when any appear",
  taxAgentMessage: "This is a message for the client:",
  documentRequestCreated: "Document request created successfully",
  documentRequestMarkedReceived: "Document request marked as received",
  markDocumentsReceivedTitle: "Mark documents as received?",
  markDocumentsReceivedDescription: "This will mark the entire document request and all required documents as received and accepted. Use this when the documents were received outside the platform, for example by email.",
  messageFrom: "Message from",
  // Upload/Request flow
  documentsNeeded: "Documents needed",
  submitRequiredDocuments: "Submit the required documents to keep your account in good standing.",
  selectOneOption: "Select one of the following options to upload",
  allDocumentsRequired: "All of the following documents are required",
  chooseEasiestDocument: "You can choose whichever document is easiest for you.",
  dragDropOrClick: "Drag & drop files or click here to upload",
  uploadDocument: "Upload {{docName}}",
  uploadYourDocuments: "Upload your documents",
  provideRequestedDocuments: "Please provide the requested documents to ensure continuous access to all platform features and compliance-related services.",
  deadline: "Deadline:",
  downloadTemplateNumber: "Download template {{number}}",
  uploadAnyOneOf: "You can upload any one of <b>{{count}}</b> available document options.",
  uploadRequiredDocuments: "You need to upload <b>{{count}}</b> required document(s).",
  oneOfDocuments: "1 of {{count}} documents",
  documentRequired: "{{count}} document required",
  documentsRequired: "{{count}} documents required",
  fileFormatsMaxSize: "({{formats}} · max {{size}} MB)",
  documentName: "Document Name:",
  dateRequested: "Date Requested:",
  dateSubmitted: "Date Submitted:",
  status: "Status:",
  comment: "Comment:",
  documentLink: "Document Link:",
  viewDocument: "View Document",
  reviewDocument: "Review Document",
  documentDetails: "Document Details",
  selectStatus: "Select Status",
  chooseStatus: "Choose status...",
  enterComment: "Enter comment...",
  youAreAllSet: "You're all set 🤍",
  whatHappensNext: "What happens next",
  teamWillReview: "Our team will review your documents. If anything else is needed, we'll message you here.",
  redirectingIn: "Redirecting in {{seconds}}s…",
  uploadFailed: "Upload failed",
  noFilesSelected: "No files selected",
  attachment: "Attachment",
  resourceSingular: "message",
  resourcePlural: "messages",
  errorWithMessage: "Error! {{error}}",
  uploadHistory: "Upload history",
};

export default labels;
